export default __webpack_public_path__ + "static/media/app-epic-ride.86713301.png";